/**
 * Menü sayfalarının merkezi erişim kararı (#825 dilim 3).
 *
 * `GET /api/data/access/me` haritasındaki `page_<yol>` anahtarları (migration 132) bugünkü
 * `routes.tsx` kuralını (adminOnly / proOnly) yansıtır. Bu dilimde tablo YALNIZ KISITLAYABİLİR:
 * kapı bugünkü kuralı (RequireAdmin / RequirePro) asla gevşetmez, tablo "erişim yok" diyorsa
 * ek olarak kapatır. Tabloyu açmak (adminOnly sayfayı herkese) sunucu zorlaması (dilim 4)
 * gelmeden yapılamaz: aksi halde sayfa açılır ama uçlar 403 verir.
 *
 * Güvenli geri düşüş: harita yok / yükleniyor / hata, anahtar haritada yok → `legacy`
 * (yalnız bugünkü kural). Hiçbir okuma hatası kimseyi kilitlemez.
 */
import type { AppRoute } from '@/app/routes'
import type { MyFeatureAccessMap } from '@/services/feature-access-api'

export type PageDecision = 'legacy' | 'denied' | 'coming_soon'

export const PAGE_KEY_PREFIX = 'page_'

/** Panelden kapatılırsa kullanıcıyı yönlendirecek yer kalmaz ya da yönetim kilitlenir: tablo bu sayfaları kısıtlayamaz. */
const NEVER_RESTRICTED = new Set<string>(['/app/dashboard', '/app/admin/extension-features'])

/** Bu sayfa panelden kısıtlanamaz (ana ekran, erişim yönetiminin kendisi). */
export function isNeverRestricted(routePath: string): boolean {
  return NEVER_RESTRICTED.has(routePath)
}

/** `/app/admin/content/blog` → `page_admin_content_blog` (migration 132 ile aynı kural). */
export function pageFeatureKey(routePath: string): string {
  return PAGE_KEY_PREFIX + routePath.replace(/^\/app\//, '').replace(/[/-]/g, '_')
}

export function decidePageAccess(
  map: MyFeatureAccessMap | undefined,
  route: Pick<AppRoute, 'path' | 'status' | 'externalUrl' | 'modalAction'>,
): PageDecision {
  if (!map) return 'legacy'
  if (NEVER_RESTRICTED.has(route.path)) return 'legacy'
  // `planned` yer tutucular (Kai, Review Automation, Ayarlar) bugün kodla yönetiliyor — `page_settings` satırı bu yüzden şimdilik etkisiz;
  // bir sayfa `ready` olunca tohumdaki kademe devreye girer. Dış bağlantı/pencere eylemi sayfa değil.
  if (route.status === 'planned' || route.externalUrl || route.modalAction) return 'legacy'
  const entry = map[pageFeatureKey(route.path)]
  if (!entry || entry.allowed === true) return 'legacy'
  return entry.outsider_view === 'coming_soon' ? 'coming_soon' : 'denied'
}
